import type { TransactionDetail } from "common/graphql";
import type { TransactionTimeAndRateBreakdownProps } from "./TransactionTimeAndRateBreakdown";

/**
 * The single flat charge for a trip charge, which has no park or policy compliance rows to price it.
 *
 * Prefers the trip_fee_cents snapshot. Charges created before the snapshot existed fall back to the
 * (negative) fee transaction_log_no_balance derives from permits. Lives in its own module so it can
 * be unit tested without TransactionDetail's Apollo query.
 */
export const getFlatCharge = (
  transaction?: Pick<
    TransactionDetail,
    "transactionType" | "status" | "tripFeeCents" | "transactionLog" | "sessionStartedAtLocal"
  > | null,
): TransactionTimeAndRateBreakdownProps["flatCharge"] =>
  transaction?.transactionType === "trip_charge"
    ? {
        chargedAt: transaction.sessionStartedAtLocal ? new Date(transaction.sessionStartedAtLocal) : undefined,
        priceCents: transaction.tripFeeCents ?? Math.abs(transaction.transactionLog?.tripFeeAmount ?? 0),
        // Voiding a trip charge sets its status to canceled; the fee is kept but never collected.
        voided: transaction.status === "canceled",
      }
    : undefined;

export default getFlatCharge;
